import { ComponentInternalInstance, computed, getCurrentInstance, Ref } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import storage from '@/renderer/scripts/utils/storage';
import { IS_BROWSER, IS_DEV, IS_DEV_PUBLISH, IS_TEST, IS_PRE } from '@/common/constant/platform';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { DrawerEvents } from '@/renderer/store/modules/drawer';
interface Handler {
  envHelp: Ref<string | boolean>;
  goToIndexPage(): Promise<void>;
}
export default function handler(): Handler {
  const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;
  const { $store } = vm;

  // 是否发布
  const envHelp = computed(() => {
    if (IS_DEV || IS_DEV_PUBLISH) {
      return i18n_t('开发环境');
    }
    if (IS_TEST) {
      return i18n_t('测试环境');
    }
    if (IS_PRE) {
      return i18n_t('预发布环境');
    }
    return false;
  });
  const methods = {
    async goToIndexPage() {
      // 未登录则进入登录页
      if (!$store.getters.isLogined) {
        dispatchRouter(
          {
            name: 'login',
          },
          'replace',
        );
        return;
      }
      if ($store.getters.isInWeMeetApp || $store.getters.isTclApp) {
        if (window.history.length > 1) {
          // 如果有上一页则直接用路由来返回上一页
          vm.$router.go(-1);
        } else {
          dispatchRouter({
            name: 'workbench',
          });
        }
      } else if (!IS_BROWSER) {
        const routeBeforePreview: any = storage.get(storage.StoreKey.ROUTE_BEFORE_PREVIEW);
        const isSameRoute = routeBeforePreview?.name === vm.$route.name;
        // 如果是在日志查询，需关闭抽屉
        if (routeBeforePreview?.name === 'logQuery') {
          $store.commit(DrawerEvents.TOGGLE_DRAWER, false);
        }
        // 由于可疑文件抽屉是单独的 所以需销毁原来的抽屉
        if (routeBeforePreview?.name === 'suspiciousFile') {
          $store.commit(DrawerEvents.TOGGLE_DRAWER, false);
          setTimeout(() => {
            $store.commit(DrawerEvents.DESTORY_DRAWER);
          }, 0);
        }
        if (!Object.keys(routeBeforePreview).length || isSameRoute) {
          dispatchRouter({
            name: 'workbench',
          });
        } else {
          dispatchRouter({
            ...routeBeforePreview,
          });
        }
      } else {
        dispatchRouter({
          name: 'workbench',
        });
      }
      if (IS_BROWSER) {
        document.title = $store.getters.defaultTitle;
      }
    },
  };
  return {
    envHelp,
    ...methods,
  };
}
